import React from 'react';

type WhiteScreenForAnimationPropsType = {
  isShow: boolean;
};
/**
 * Component for smooth animation between screens
 * Logic: The user goes to a new page and should go to it smoothly,
 * for this feature, a white screen background is used,
 * which is removed after a few ms
 */
const WhiteScreenForAnimation: React.FC<WhiteScreenForAnimationPropsType> = ({ isShow }) => {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        background: 'white',
        position: 'absolute',
        zIndex: 99999,
        pointerEvents: isShow ? 'auto' : 'none',
        opacity: isShow ? 1 : 0,
        transition: '0.5s ease-in-out',
      }}
    />
  );
};

export default WhiteScreenForAnimation;
